<template>
    <rkm-form
        ref="Form"
        show-legend
    >
        <rkm-row>
            <rkm-col>
                <rkm-form-select
                    :options="gruposExamesRegulados"
                    :validations="validations.grupoExameRegulado"
                    label="Grupo de exame / Exame regulado"
                    show-default-option
                    text-field="descricao"
                    v-model="model.grupoExameReguladoKey"
                    value-field="key"
                />
            </rkm-col>

            <rkm-col cols="auto">
                <rkm-button
                    :label="false"
                    @click="$refs.Form.validate(add)"
                    color="primary"
                >
                    Incluir
                </rkm-button>
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Mixins.
import { object, formats } from '@/mixins'

export default {
    computed: {
        validations() {

            return {
                grupoExameRegulado: { required: true },
            }
        },
        gruposExamesRegulados() {

            const exames = this.data.model.reguladores.find(r => r.infraestruturaId === this.regulador.infraestruturaId)
                .exames
                .filter(e => e.ativo && !this.examesReguladosDoReguladorIds.includes(e.id))
                .map(exame => ({
                    key: `exame#${exame.id}`,
                    origem: 'exame',
                    id: exame.id,
                    codigo: exame.codigo,
                    nome: exame.nome,
                    grupoId: exame.grupoId,
                    grupoNome: exame.grupoNome,
                    descricao: exame.codigo ? `${this.formatProcedimento(exame.codigo)} - ${exame.nome}` : exame.nome
                }))

            const grupos = []

            exames.forEach(exame => {

                if (!grupos.find(g => g.id === exame.grupoId)) {

                    grupos.push({
                        key: `grupo#${exame.grupoId}`,
                        origem: 'grupo',
                        id: exame.grupoId,
                        descricao: exame.grupoNome
                    })
                }
            })

            return exames.concat(grupos).sort((a, b) => a.descricao.localeCompare(b.descricao))
        },
        examesReguladosDoReguladorIds() {

            return this.regulador.exames.map(e => e.id)
        }
    },
    data: () => ({
        model: {
            grupoExameReguladoKey: null,
        }
    }),
    methods: {
        add() {

            let [origem, id] = this.model.grupoExameReguladoKey.split('#')

            id = parseInt(id)

            if (origem === 'exame') {

                this.regulador.exames.push(this.prepareData(id))
            }
            else {

                this.getExamesIds(id)
                    .filter(id => !this.examesReguladosDoReguladorIds.includes(id))
                    .forEach(id => this.regulador.exames.push(this.prepareData(id)))
            }

            this.resetForm()
        },
        getExamesIds(grupoId) {

            return this.gruposExamesRegulados
                .filter(e => e.origem === 'exame' && e.grupoId === grupoId)
                .map(e => e.id)
        },
        prepareData(exameId) {

            return this.clone(this.gruposExamesRegulados.find(e => e.origem === 'exame' && e.id === exameId))
        },
        resetForm() {

            this.model.grupoExameReguladoKey = null

            this.$nextTick().then(() => this.$refs.Form.resetValidator())
        }
    },
    mixins: [object, formats],
    props: {
        data: { type: Object, required: true },
        regulador: { type: Object, required: true },
    },
}
</script>